<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Wybieranie użytkownika, któremu będziesz edytować grupy
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label>Wybierz użytownika</label>
                            <search-client type="all" v-on:selected="selected"/>
                        </div>
                        <div v-if="currentUser.dbid">
                            <hr>
                            <div class="pb-2">Edytujesz grupy użytkownika:</div>
                            <client :client="currentUser" withAvatar />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="currentUser.dbid">
            <div
                v-for="(section, sectionName, index) of cfg.zones"
                  :key="sectionName"
                  class="col-xl-4 col-lg-6"
            >
                <div class="card">
                    <div class="card-header">
                        <h3><i v-if="section.icon" :class="section.icon"></i> {{ sectionName }}</h3>
                        <h6>Limit: {{ section.limit }}</h6>
                    </div>
                    <div class="card-body">
                        <select-server-groups :groups="section.groups" :limit="section.limit" :ref="'select-' + index" byHasProp/>
                    </div>
                    <div class="card-footer d-flex justify-content-center">
                        <button
                            class="btn btn-primary"
                            @click="handleSave(index)"
                        ><i class="fa fa-check"></i> Zapisz
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ManageGroupsService from "@/services/manage-groups.service";
import {
    notificationMethods
} from "@/state/helpers";

/**
 * Starter component
 */
export default {
    name: "ManageGroups",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "Zarządzanie grupami",
            items: [
                {
                    text: "Admin",
                    href: "/"
                },
                {
                    text: "Zarządzanie grupami",
                    active: true
                }
            ],
            loading: false,
            cfg: {},
            currentUser: {}
        };
    },
    methods: {
        ... notificationMethods,
        selected(user) {
            this.currentUser = user;
            this.loadGroups();
        },
        loadGroups() {
            this.loading = true;

            ManageGroupsService.getData(this.currentUser.dbid).then(
                response => {
                    this.cfg = response.data;
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        handleSave(index) {
            this.loading = true;
            let groups = this.$refs['select-' + index][0].getSelected();

            if (groups.length > 0)
                groups = groups.map(g => g.sgid)
            else
                groups = null;

            ManageGroupsService.change(this.currentUser.dbid, index, groups).then(
                () => {
                    this.success("Grupy klienta zostały zmienione");
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        }
    }
};
</script>